import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuiltFocus } from "../context/QuiltFocusContext";

export default function QuiltDeepLinkRedirect({ kind }) {
  const navigate = useNavigate();
  const params = useParams();
  const { requestFocus } = useQuiltFocus();

  useEffect(() => {
    const id = params.id;
    if (!id) {
      navigate("/graph", { replace: true });
      return;
    }
    requestFocus({ kind, id });
    navigate("/graph", { replace: true });
  }, [kind, navigate, params.id, requestFocus]);

  return null;
}
